angular.module('LegendSettings', ['ui.bootstrap', 'textAngular']);
